import { useState } from "react";
import { Button } from "@/shared/components/ui/button";
import { Input } from "@/shared/components/ui/input";
import SecondaryIcon from "../../../../../shared/components/SecondaryIcon";
import Icons from "../../../../../shared/constants/icon.constant";

interface DepositFundsEnterAmountProps {
  onSubmit(amount: string): void;
}

export default function DepositFundsEnterAmount({
  onSubmit,
}: Readonly<DepositFundsEnterAmountProps>) {
  const [amount, setAmount] = useState("");

  return (
    <div className="w-full mx-auto bg-transparent p-0 space-y-2">
      <div>
        <div className="relative">
          <Input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Amount"
            min="0"
            step="any"
            className="pr-16"
          />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-muted-foreground">
            USD
          </span>
        </div>
      </div>
      <Button
        onClick={() => onSubmit(amount)}
        className="w-full"
        disabled={!amount || Number(amount) <= 0}>
        Continue
      </Button>
      <div className="text-xs text-label-dark space-y-4 pt-4">
        <p>
          By Clicking the Deposit button, I agree to the Terms of the{" "}
          <b className="text-white">Customer Agreement</b> and the{" "}
          <b className="text-white">Anti-Money Laundering Policy</b>, and
          confirm that the{" "}
          <b className="text-white">
            payment will not be made from a third-party account
          </b>{" "}
          .
        </p>
        {/* <div className="border-t border-gray-700 border-dashed"></div> */}
        {/* <div className="flex items-center gap-2 mb-2">
          <SecondaryIcon
            icon={Icons.DepositAmountIcon({ width: 15, height: 15 })}
            isActive
          />
          <p className="text-white">Minimum Amount: $3</p>
        </div> */}
        <div className="border-t border-gray-700 border-dashed"></div>
        <div className="flex items-center gap-2 mb-2">
          <SecondaryIcon
            icon={Icons.TimeIcon({ width: 15, height: 15 })}
            isActive
          />
          <p className="text-white">
            Processing time: Up to 2 hours (may vary)
          </p>
        </div>
        <div className="border-t border-gray-700 border-dashed"></div>
        <div className="flex items-center gap-2 mb-2">
          <SecondaryIcon
            icon={Icons.InfoIcon({ width: 15, height: 15 })}
            isActive
          />
          <a href="#" className="text-white underline">
            Additional info.
          </a>
        </div>
      </div>
    </div>
  );
}
